module.exports = __webpack_public_path__ + "img/no_table.e85825e6.png";